// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__2ibyK","logoWrap":"Footer_logoWrap__25-D3","logo":"Footer_logo__2cKTD"};